export default "__VITE_ASSET__BAu0vR6O__"